module.exports = __webpack_public_path__ + "static/media/Login-Background@2x.7bd4274a.jpg";